import React from 'react';

const ArrowBackIcon = ({ className }) => (
  <svg
    className={className}
    width="21"
    height="13"
    viewBox="0 0 21 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9141 6H1.41406M1.41406 6L6.41406 1M1.41406 6L6.91406 11.5"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export default ArrowBackIcon;
